import { OptionTuple } from '~/components/Input/Select/Select';
import { ForwardedRef, forwardRef, useMemo } from 'react';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { useRegionListQuery } from '../queries';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'>;

function RegionSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useRegionListQuery();

  const options = useMemo<OptionTuple[]>(() => {
    return data.map(region => [region.name, region.id]);
  }, [data]);

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Alla regioner'}
      disabled={isLoading || props.disabled}
      options={options}
      ref={ref}
      {...props}
    />
  );
}

export const RegionSelect = forwardRef(RegionSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof RegionSelectElement>;
